var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.args !== null )?_c('div',{staticClass:"icon",on:{"click":function($event){return _vm.getHelper()}}},[_c('img',{staticClass:"info",attrs:{"src":"/icon-info.svg"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }